module.exports = lib_ui__shallowequal;